import { inject, Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';

/**
 * Prepends the app brand to every route's title.
 *
 * Usage: add `title: 'Login'` to a route, and the tab becomes "Dealiodesk - Login".
 * Routes without a `title` fall back to just "Dealiodesk".
 *
 * Wired up in app.config.ts via:
 *   { provide: TitleStrategy, useClass: DealiodeskTitleStrategy }
 */
@Injectable({ providedIn: 'root' })
export class DealiodeskTitleStrategy extends TitleStrategy {
  private static readonly _APP_NAME = 'Dealiodesk';

  private readonly _title = inject(Title);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this._title.setTitle(
      pageTitle
        ? `${DealiodeskTitleStrategy._APP_NAME} - ${pageTitle}`
        : DealiodeskTitleStrategy._APP_NAME
    );
  }
}
